module.exports = __webpack_public_path__ + "static/media/x-plane.345b0a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgressBar/assets/x-plane.png
// module id = ko9u
// module chunks = 23